import angular from 'angular';
import {
  ssDialogService,
} from 'app/services';

import template from './edit-change-log-attributes-dialog.html';
import controller from './edit-change-log-attributes-dialog.controller';
import explanationTpl from './messages/explanation.messages.html';

class dialogService {
  getOptions({ changeLogItem }) {
    return {
      controller,
      controllerAs: 'editChangeLogAttributesDialogVM',
      locals: {
        changeLogItem
      },
      bindToController: true,
      escapeToClose: false,
      clickOutsideToClose: false,
      template,
    };
  }
}

export default angular.module('app.components.advisory.pm.editChangeLogAttributesDialog', [
  ssDialogService
])
  .service('editChangeLogAttributesDialog', dialogService)
  .run(($templateCache) => {
    $templateCache.put('explanation.messages.html', explanationTpl);
  })
  .name;
